"use client";

import { getDaysToDateInFuture } from "@/service/date/day";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { trans } from "@/service/i18n/i18n";
import { MonitorPlayIcon } from "lucide-react";
import { RenewModal } from "./renew-modal";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export const RenewCourseButton = ({ course }: { course: MyCourseVM }) => {
  const [isRenewalModalOpen, setIsRenewalModalOpen] = useState(false);
  const { renew, coverImage, title } = course;

  if (!renew) {
    return <></>;
  }

  const { expiredAt } = renew;

  const daysUntilExpired = getDaysToDateInFuture(new Date(expiredAt));

  const canRenew = daysUntilExpired <= 30;

  const daysPlural = daysUntilExpired === 1 ? "dzień" : "dni";

  return (
    <>
      <span
        {...(!canRenew
          ? {}
          : {
              "data-title": trans("education.course.renew"),
            })}
      >
        <Button
          variant={canRenew ? "blue" : "secondary"}
          disabled={!canRenew}
          onClick={() => setIsRenewalModalOpen(true)}
        >
          <MonitorPlayIcon className="h-4 w-4" />
          {daysUntilExpired < 1
            ? `Dostęp kończy się dziś!`
            : `Dostęp do kursu: ${daysUntilExpired} ${daysPlural}`}
        </Button>
      </span>
      <Dialog
        className={""}
        open={isRenewalModalOpen}
        onOpenChange={setIsRenewalModalOpen}
      >
        <DialogContent className="mx-auto w-4/5 max-w-[670px]">
          <RenewModal
            renew={renew}
            image={coverImage}
            title={title}
            setIsOpen={setIsRenewalModalOpen as (value: boolean) => void}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
